import { useState, useRef } from "react";
import MapeoMeta from "./MapeoMeta";

// ── Descripción y guía de exportación por archivo ────────────────────────────

const ARCHIVOS = [
  {
    key: "pedidos",
    label: "Pedidos Dropi",
    icono: "📦",
    descripcion: "Órdenes con productos exportadas desde Dropi",
    columnas: ["ID", "PRODUCTO", "ESTATUS", "FECHA", "Total de la orden", "TRANSPORTADORA"],
    pasos: [
      "Entra a Dropi → menú lateral Pedidos",
      "Filtra por rango de fechas (recomendado: últimos 30 días)",
      "Haz clic en el menú Acciones",
      'Selecciona "Órdenes con productos (un producto por fila)"',
      "Descarga en formato XLSX",
    ],
  },
  {
    key: "finanzas",
    label: "Finanzas Dropi",
    icono: "💰",
    descripcion: "Historial de Cartera exportado desde Dropi",
    columnas: ["ORDEN ID", "TIPO", "MONTO", "FECHA"],
    pasos: [
      "Entra a Dropi → menú lateral Historial de Cartera",
      "Selecciona el mismo período de fechas que los pedidos",
      'Haz clic en el botón azul "Descargar en Excel"',
      "Descarga en formato XLSX",
    ],
  },
  {
    key: "meta",
    label: "Campañas Meta Ads",
    icono: "📣",
    descripcion: "Vista general de campañas exportada desde Meta Business",
    columnas: ["Nombre de la campaña", "Importe gastado (CLP)", "Impresiones", "Clics en el enlace"],
    pasos: [
      "Entra a Meta Business → Administrador de Anuncios",
      "Asegúrate de estar en la vista Campañas (no conjuntos ni anuncios)",
      "Selecciona el mismo período de fechas",
      "Haz clic en Exportar",
      "Descarga en formato XLSX",
    ],
  },
];

// ── Componente de error estructurado ─────────────────────────────────────────

function ErrorValidacion({ errores, onReintentar }) {
  const [expandido, setExpandido] = useState(null);

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: "2rem 0" }}>
      {/* Header error */}
      <div style={{ background: "#FCEBEB", border: "1px solid #F5C6C6", borderRadius: 12, padding: "16px 18px", marginBottom: "1.25rem" }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: "#7B1E1E", marginBottom: 4 }}>
          ⚠️ Formato de archivo incorrecto
        </div>
        <div style={{ fontSize: 13, color: "#A32D2D" }}>
          {errores.length === 1
            ? "Uno de los archivos no tiene el formato esperado."
            : `${errores.length} archivos tienen problemas de formato.`} Revisa los detalles y vuelve a intentarlo.
        </div>
      </div>

      {/* Detalle por archivo */}
      {errores.map((err, i) => (
        <div key={i} style={{ border: "1px solid #FBD5D5", borderRadius: 10, overflow: "hidden", marginBottom: 10, background: "#fff" }}>
          <button
            onClick={() => setExpandido(expandido === i ? null : i)}
            style={{
              width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "12px 16px", background: "none", border: "none", cursor: "pointer", textAlign: "left",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18 }}>
                {ARCHIVOS.find(a => a.label === err.archivo)?.icono || "📄"}
              </span>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#7B1E1E" }}>{err.archivo}</div>
                <div style={{ fontSize: 12, color: "#A32D2D", marginTop: 1 }}>{err.mensaje}</div>
              </div>
            </div>
            <span style={{ fontSize: 12, color: "#bbb", flexShrink: 0 }}>{expandido === i ? "▲" : "▼"}</span>
          </button>

          {expandido === i && (
            <div style={{ padding: "0 16px 16px", borderTop: "0.5px solid #FBD5D5" }}>
              {err.columnas_faltantes?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>
                    Columnas faltantes
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                    {err.columnas_faltantes.map(c => (
                      <span key={c} style={{ fontSize: 11, padding: "3px 10px", borderRadius: 20, background: "#FCEBEB", color: "#A32D2D", border: "1px solid #F5C6C6", fontFamily: "monospace" }}>
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {err.columnas_encontradas?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>
                    Columnas encontradas en el archivo
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {err.columnas_encontradas.map(c => (
                      <span key={c} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: "#f5f5f4", color: "#666", fontFamily: "monospace" }}>
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {err.ayuda && (
                <div style={{ marginTop: 12, background: "#FEF9EC", border: "1px solid #F0C040", borderRadius: 8, padding: "10px 14px" }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#7D5A00", marginBottom: 3 }}>Cómo corregirlo</div>
                  <div style={{ fontSize: 12, color: "#7D5A00", lineHeight: 1.6 }}>{err.ayuda}</div>
                </div>
              )}
            </div>
          )}
        </div>
      ))}

      <button
        onClick={onReintentar}
        style={{
          marginTop: "0.5rem", width: "100%", padding: "11px", borderRadius: 10,
          border: "0.5px solid #ddd", background: "#fff", fontSize: 13,
          fontWeight: 500, color: "#333", cursor: "pointer",
        }}
      >
        ← Volver e intentar de nuevo
      </button>
    </div>
  );
}

// ── Componente principal ──────────────────────────────────────────────────────

// paso: "seleccion" | "analizando" | "mapeo" | "generando" | "exito" | "error_validacion" | "error"

export default function CargaArchivos({ apiUrl, onExito }) {
  const [archivos,    setArchivos]    = useState({ pedidos: null, finanzas: null, meta: null });
  // validacion[key] = null | "validando" | { ok: true, n_filas, columnas_encontradas } | { ok: false, mensaje, columnas_faltantes }
  const [validacion,  setValidacion]  = useState({ pedidos: null, finanzas: null, meta: null });
  const [paso,        setPaso]        = useState("seleccion");
  const [mensaje,     setMensaje]     = useState("");
  const [erroresVal,  setErroresVal]  = useState(null); // lista de errores estructurados
  const [datosMapeo,  setDatosMapeo]  = useState(null);
  const [guiaAbierta, setGuiaAbierta] = useState(null); // key del archivo con guía abierta
  const refs = { pedidos: useRef(), finanzas: useRef(), meta: useRef() };

  // Valida un archivo individual contra el backend al ser seleccionado.
  // Da feedback inmediato (✓ / ✗) sin esperar al click "Generar panel".
  const validarArchivoIndividual = async (key, file) => {
    if (!file) {
      setValidacion(prev => ({ ...prev, [key]: null }));
      return;
    }
    setValidacion(prev => ({ ...prev, [key]: "validando" }));
    const formData = new FormData();
    formData.append("tipo", key);
    formData.append("archivo", file);
    try {
      const res = await fetch(`${apiUrl}/api/validar-archivo`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formData,
      });
      const data = await res.json();
      setValidacion(prev => ({ ...prev, [key]: data }));
    } catch (e) {
      setValidacion(prev => ({ ...prev, [key]: { ok: false, mensaje: "Error de red al validar archivo." } }));
    }
  };

  const seleccionar = (key, file) => {
    setArchivos(prev => ({ ...prev, [key]: file }));
    validarArchivoIndividual(key, file);
    if (paso !== "seleccion") {
      setPaso("seleccion");
      setMensaje("");
      setErroresVal(null);
      setDatosMapeo(null);
    }
  };

  const todosSeleccionados = ARCHIVOS.every(a => archivos[a.key]);
  const algunErrorValidacion = ARCHIVOS.some(a =>
    validacion[a.key] && validacion[a.key] !== "validando" && validacion[a.key].ok === false
  );
  const algunValidando = ARCHIVOS.some(a => validacion[a.key] === "validando");
  const puedeAnalizar = todosSeleccionados && !algunErrorValidacion && !algunValidando;

  // Parsea la respuesta de error del backend → lista de errores estructurados
  const parsearError = async (res) => {
    try {
      const body = await res.json();
      if (body?.detail?.errores) return body.detail.errores;
      if (body?.detail) return [{ archivo: "General", mensaje: body.detail, columnas_faltantes: [], columnas_encontradas: [], ayuda: "" }];
    } catch {}
    return [{ archivo: "General", mensaje: `Error ${res.status}`, columnas_faltantes: [], columnas_encontradas: [], ayuda: "Verifica que los archivos sean XLSX válidos." }];
  };

  // ── Paso 1: Analizar Meta ─────────────────────────────────────────────────
  const handleAnalizar = async () => {
    setPaso("analizando");
    setMensaje("");
    setErroresVal(null);
    const formData = new FormData();
    formData.append("pedidos", archivos.pedidos);
    formData.append("meta",    archivos.meta);
    try {
      const res = await fetch(`${apiUrl}/api/analizar-meta`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formData,
      });
      if (!res.ok) {
        const errs = await parsearError(res);
        setErroresVal(errs);
        setPaso("error_validacion");
        return;
      }
      const data = await res.json();
      setDatosMapeo(data);
      setPaso("mapeo");
    } catch (e) {
      setPaso("error");
      setMensaje(e.message || "Error de conexión. Intenta de nuevo.");
    }
  };

  // ── Paso 2: Generar panel ─────────────────────────────────────────────────
  const handleGenerar = async (mapeoFinal) => {
    setPaso("generando");
    setMensaje("");
    setErroresVal(null);
    const formData = new FormData();
    formData.append("pedidos",  archivos.pedidos);
    formData.append("finanzas", archivos.finanzas);
    formData.append("meta",     archivos.meta);
    formData.append("mapeo",    JSON.stringify(mapeoFinal));
    try {
      const res = await fetch(`${apiUrl}/api/generar`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formData,
      });
      if (!res.ok) {
        const errs = await parsearError(res);
        setErroresVal(errs);
        setPaso("error_validacion");
        return;
      }
      setPaso("exito");
      setMensaje("Panel generado exitosamente. Cargando dashboard...");
      setTimeout(onExito, 1500);
    } catch (e) {
      setPaso("error");
      setMensaje(e.message || "Error de conexión. Intenta de nuevo.");
    }
  };

  const handleReset = () => {
    setArchivos({ pedidos: null, finanzas: null, meta: null });
    setPaso("seleccion");
    setMensaje("");
    setErroresVal(null);
    setDatosMapeo(null);
    ARCHIVOS.forEach(a => { if (refs[a.key]?.current) refs[a.key].current.value = ""; });
  };

  // ── Vistas especiales ─────────────────────────────────────────────────────

  if (paso === "mapeo" && datosMapeo) {
    return (
      <MapeoMeta
        productos={datosMapeo.productos}
        mapeos={datosMapeo.mapeos}
        onConfirmar={handleGenerar}
        onVolver={() => { setPaso("seleccion"); setDatosMapeo(null); }}
      />
    );
  }

  if (paso === "error_validacion" && erroresVal) {
    return <ErrorValidacion errores={erroresVal} onReintentar={handleReset} />;
  }

  // ── Vista principal: selección de archivos ────────────────────────────────
  const cargando = paso === "analizando" || paso === "generando";

  return (
    <div style={{ maxWidth: 580, margin: "0 auto", padding: "2rem 0" }}>

      {/* Encabezado */}
      <div style={{ marginBottom: "1.5rem" }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, margin: "0 0 6px 0" }}>Cargar archivos Excel</h2>
        <p style={{ fontSize: 13, color: "#888", margin: 0 }}>
          Sube los tres archivos para generar el Panel Estratégico. Despliega cada tarjeta para ver cómo exportar correctamente.
        </p>
      </div>

      {/* Tarjetas de archivos */}
      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", marginBottom: "1.5rem" }}>
        {ARCHIVOS.map(({ key, label, icono, descripcion }) => {
          const seleccionado = !!archivos[key];
          const guiaVisible  = guiaAbierta === key;
          return (
            <div key={key} style={{ border: seleccionado ? "1px solid #1D9E75" : "0.5px solid #e0e0de", borderRadius: 12, overflow: "hidden", background: seleccionado ? "#f4fbf8" : "#fafaf9", transition: "border-color 0.15s" }}>
              {/* Fila principal */}
              <div
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px", cursor: cargando ? "default" : "pointer", opacity: cargando ? 0.6 : 1 }}
                onClick={() => !cargando && refs[key].current?.click()}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ fontSize: 20 }}>{icono}</span>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500, color: "#111" }}>
                      {seleccionado ? "✓ " : ""}{label}
                    </div>
                    <div style={{ fontSize: 11, color: "#999", marginTop: 1 }}>
                      {seleccionado ? archivos[key].name : descripcion}
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ fontSize: 11, padding: "4px 12px", borderRadius: 20, background: seleccionado ? "#1D9E75" : "transparent", color: seleccionado ? "#fff" : "#888", border: seleccionado ? "none" : "0.5px solid #ddd", whiteSpace: "nowrap" }}>
                    {seleccionado ? "Cambiar" : "Seleccionar"}
                  </div>
                  {/* Botón guía */}
                  <button
                    onClick={e => { e.stopPropagation(); setGuiaAbierta(guiaVisible ? null : key); }}
                    title="Ver instrucciones de exportación"
                    style={{ fontSize: 12, padding: "4px 10px", borderRadius: 20, border: "0.5px solid #e0e0de", background: guiaVisible ? "#EEF2FF" : "transparent", color: guiaVisible ? "#4338CA" : "#aaa", cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    ? Ayuda
                  </button>
                </div>
                <input ref={refs[key]} type="file" accept=".xlsx" style={{ display: "none" }} onChange={e => seleccionar(key, e.target.files[0] || null)} />
              </div>

              {/* Feedback de validación inmediata */}
              {seleccionado && validacion[key] && (
                <div style={{
                  borderTop: "0.5px solid #e8e8e6",
                  padding: "8px 16px",
                  background: validacion[key] === "validando" ? "#fafaf9"
                    : validacion[key].ok ? "#f0fdf4" : "#fef2f2",
                  fontSize: 12,
                }}>
                  {validacion[key] === "validando" && (
                    <span style={{ color: "#888" }}>Validando formato...</span>
                  )}
                  {validacion[key] !== "validando" && validacion[key].ok && (
                    <span style={{ color: "#15803d", fontWeight: 600 }}>
                      ✓ {validacion[key].n_filas?.toLocaleString("es-CL") ?? "?"} filas detectadas — formato correcto
                    </span>
                  )}
                  {validacion[key] !== "validando" && !validacion[key].ok && (
                    <div style={{ color: "#b91c1c" }}>
                      <div style={{ fontWeight: 600, marginBottom: 4 }}>
                        ✗ {validacion[key].mensaje || "Formato incorrecto"}
                      </div>
                      {validacion[key].columnas_faltantes?.length > 0 && (
                        <div style={{ fontSize: 11, color: "#7f1d1d" }}>
                          Columnas faltantes: {validacion[key].columnas_faltantes.join(", ")}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Panel de guía expandible */}
              {guiaVisible && (
                <div style={{ borderTop: "0.5px solid #e8e8e6", padding: "12px 16px", background: "#fff" }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "#4338CA", marginBottom: 8 }}>Cómo exportar este archivo</div>
                  <ol style={{ margin: 0, padding: "0 0 0 16px", display: "flex", flexDirection: "column", gap: 5 }}>
                    {ARCHIVOS.find(a => a.key === key).pasos.map((p, i) => (
                      <li key={i} style={{ fontSize: 12, color: "#444", lineHeight: 1.5 }}>{p}</li>
                    ))}
                  </ol>
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 11, color: "#888", marginBottom: 5, fontWeight: 500 }}>Columnas requeridas:</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                      {ARCHIVOS.find(a => a.key === key).columnas.map(c => (
                        <span key={c} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: "#EEF2FF", color: "#4338CA", fontFamily: "monospace" }}>{c}</span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Botón principal */}
      <button
        onClick={handleAnalizar}
        disabled={!puedeAnalizar || cargando}
        style={{
          width: "100%", padding: "12px", borderRadius: 10, border: "none",
          background: puedeAnalizar && !cargando ? "#111" : "#e0e0de",
          color: puedeAnalizar && !cargando ? "#fff" : "#aaa",
          fontSize: 14, fontWeight: 500,
          cursor: puedeAnalizar && !cargando ? "pointer" : "default",
          transition: "background 0.15s",
        }}
      >
        {paso === "analizando" ? "Analizando campañas Meta..." : paso === "generando" ? "Generando panel..." : "Analizar y mapear campañas →"}
      </button>

      {/* Mensaje de éxito o error genérico */}
      {mensaje && (
        <div style={{
          marginTop: "1rem", padding: "12px 16px", borderRadius: 10,
          background: paso === "exito" ? "#EAF3DE" : "#FCEBEB",
          color: paso === "exito" ? "#3B6D11" : "#A32D2D",
          fontSize: 13,
        }}>
          {mensaje}
        </div>
      )}

      {paso === "error" && (
        <button onClick={handleReset} style={{ marginTop: "0.75rem", fontSize: 12, padding: "6px 14px", borderRadius: 8, border: "0.5px solid #ddd", background: "transparent", cursor: "pointer" }}>
          Reintentar
        </button>
      )}
    </div>
  );
}
